import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { setApgarPulseOptions } from '../store/options.actions'

import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getApgarPulseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const apgarPulse: IOptionsResponse = yield call([vitalsService, vitalsService.getApgarPulse])
    const { entity } = apgarPulse
    yield put(setApgarPulseOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getApgarPulseOptions() error: ${e}`))
  }
}

export function* getApgarPulseOptionsSaga() {
  yield takeLatest(ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, getApgarPulseOptions)
}
